export function updateIdsRecursive(elements) {
	/**
	 * DOC
	 *
	 *la funzione cambia ricorsivamente gli id degli elementi contenuti dentro un altro elemento al "clone"
	 * se il cambio degli id non venisse effettuato, vue considererebbe gli elementi dell'elemento clonato
	 * uguali e modificando il valore si cambia a tutti come se fossero lo stesso
	 *
	 * è ricorsiva per semplicità
	 *
	 * */
	elements.forEach((element, indx, array) => {
		array[indx].forEach((element2, indx2, array2) => {
			array[indx][indx2].id = Math.random().toString(16).slice(2)

			if (array[indx][indx2].items) {
				array[indx][indx2].items = updateIdsRecursive(array[indx][indx2].items)
			}
		})
	})

	return elements
}
export function cloneAt(section, idx) {
	/**
	 * DOC
	 *
	 * clona l'elemento nella lista elmenti attuale (items)
	 * viene passata la lista "section" e l'id "idx"
	 *
	 * */
	let toclone = clone(section[idx])
	if (toclone.items) {
		toclone.items = updateIdsRecursive(toclone.items)
	}
	section.splice(idx + 1, 0, toclone)
}

export function clone(original) {
	/**
	 * DOC
	 *
	 * la funzione cambia l'id univoco dell'elemento ed elimina i riferimenti interni di vue (che tratterebbero il clone come l'originale)
	 * con il trick parse-stringify
	 *
	 * */

	//necessario per far rimuovere a vue i riferimenti getter e setter nascosti
	//in alternativa, usare .map(o => ({...o}))
	const clone = JSON.parse(JSON.stringify(original))
	clone.id = uuid(clone)
	return clone
}

export function uuid(e) {
	/**
	 * DOC
	 * ritorna chiave randomica
	 * */

	var newkey = Math.random().toString(16).slice(2)

	return newkey
}
